/**
 * Codelist of predicate edit types, those determine input type.
 */
export var PredicateEditType;
(function (PredicateEditType) {
    PredicateEditType["String"] = "string";
    PredicateEditType["Date"] = "date";
    PredicateEditType["Codelist"] = "codelist";
})(PredicateEditType || (PredicateEditType = {}));
